import { useQuery } from '@apollo/client';
import { Empty } from 'antd';
import { useNavigate } from 'react-router-dom';
import {
  ApplicantProfileApplyToViewContainerApplicantUserDocument,
  ApplicantProfileApplyToViewContainerApplicantUserFieldsFragment
} from '../../../../generated';
import { ComponentQueryLoader } from '../../../shared/component-query-loader';
import { ProfileApplyToView } from './profile-apply-to-view';

interface ProfileApplyToViewContainerProps {
  data: {
    applicantId: string;
  };
}

export const ProfileApplyToViewContainer: React.FC<ProfileApplyToViewContainerProps> = (props) => {
  const navigate = useNavigate();

  // Query to get the applicant's applying to data
  const {
    data: applyingToData,
    loading: applyingToLoading,
    error: applyingToError
  } = useQuery(ApplicantProfileApplyToViewContainerApplicantUserDocument, {
    variables: {
      id: props.data.applicantId
    }
  });

  const handleEditToggle = () => {
    navigate(location.pathname.replace(/\/[^/]+$/, '/edit'));
  };

  return (
    <ComponentQueryLoader
      loading={applyingToLoading}
      error={applyingToError}
      hasData={!!applyingToData}
      hasDataComponent={
        <ProfileApplyToView
          data={applyingToData?.applicantUser as ApplicantProfileApplyToViewContainerApplicantUserFieldsFragment}
          onEditToggle={handleEditToggle}
        />
      }
      noDataComponent={<Empty description="No data available" />}
    />
  );
};
